export default {
	EMPLOYMENT_POSITIONS: 'Employment positions',
	MONEYBALL_SUB_POSITION_TABLE_TITLE: 'Moneyball sub positions',
	ACTIVE: 'Active',
	SEND_DOCUMENT: 'Send document',
};
